module.exports = __webpack_public_path__ + "static/media/rabbit-fast.fb5d3aa6.svg";